export default "__VITE_ASSET__n$GzNFLC__"